import React, { useState } from "react";
import "./ContactUs.css";
import contact_img from "../../assets/banner/contact_img.jpg";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaGlobe,
  FaFacebook,
  FaLinkedin,
  FaYoutube,
  FaInstagram,
  FaCheckCircle,
  FaTimes
} from "react-icons/fa";
import { FiSend } from "react-icons/fi";

const ContactUs = () => {
  const [isSubmitted, setIsSubmitted] = useState(false);

  const mapSrc =
    "https://maps.google.com/maps?q=LilyPond%20Center%2C%203%2C%20R.%20K%20Mission%20Road%2C%20Motijheel%2C%20Dhaka-1000&t=&z=13&ie=UTF8&iwloc=&output=embed";

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitted(true);
    e.target.reset();
  };

  const closeModal = () => setIsSubmitted(false);

  return (
    <div className="contact-section">

      {/* ===== Banner ===== */}
      <div className="contact-banner">
        <img src={contact_img} alt="Contact Us" />
      </div>

      <div className="contact-container">

        {/* Header */}
        <div className="contact-header">
          <h2 style={{ color: "#00c3ff" }}><span style={{ color: "#c004d4" }}>GET IN</span> TOUCH</h2>
          <p>
            Have any questions? Reach out to us directly or fill out the form
            below. We are here to help!
          </p>
        </div>

        <div className="contact-row">

          {/* Left */}
          <div className="contact-info-col">
            <h3>Contact Information</h3>

            <div className="info-item">
              <div className="title-row">
                <FaMapMarkerAlt className="info-icon" />
                <h4>Our Office</h4>
              </div>
              <p>
                Suite: 8/A&B, LilyPond Center,
                3, R. K Mission Road, Motijheel,
                Dhaka-1000, Bangladesh
              </p>
            </div>

            <div className="info-item">
              <div className="title-row">
                <FaEnvelope className="info-icon" />
                <h4>Email Us</h4>
              </div>
              <p>info@iconicunitygroup.com</p>
            </div>

            <div className="info-item">
              <div className="title-row">
                <FaGlobe className="info-icon" />
                <h4>Visit Website</h4>
              </div>
              <p>www.iconicunitygroup.com</p>
            </div>

            <div className="info-item">
              <div className="title-row">
                <FaPhoneAlt className="info-icon" />
                <h4>Call Us</h4>
              </div>
              <p>Hotline: 01824800900<br />Phone: 01711183777</p>
            </div>

            <div className="social-links">
              <h4>Follow Us</h4>
              <div className="social-icons">
                <a target="_blank"
                  rel="noopener noreferrer" href="https://www.facebook.com/groups/1793092464521824/" className="social-icon fb"><FaFacebook /></a>
                <a target="_blank"
                  rel="noopener noreferrer" href="https://www.linkedin.com/company/iconicunitygroup" className="social-icon li"><FaLinkedin /></a>
                <a target="_blank"
                  rel="noopener noreferrer" href="https://www.youtube.com/@iuggulshan" className="social-icon yt"><FaYoutube /></a>
                <a target="_blank"
                  rel="noopener noreferrer" href="https://www.instagram.com/popular/iconic-unity-group/" className="social-icon ig"><FaInstagram /></a>
              </div>
            </div>
          </div>

          {/* Right */}
          <div className="contact-form-col">
            <h3>Send a Message</h3>
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-group">
                <label>Name</label>
                <input type="text" required />
              </div>

              <div className="form-group">
                <label>Email</label>
                <input type="email" required />
              </div>

              <div className="form-group">
                <label>Mobile</label>
                <input type="tel" required />
              </div>

              <div className="form-group">
                <label>Subject</label>
                <input type="text" required />
              </div>

              <div className="form-group">
                <label>Message</label>
                <textarea rows="3" required></textarea>
              </div>

              <button type="submit" className="submit-btn">
                <span>Send Message</span>
                <FiSend />
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* Map */}
      <div className="full-width-map">
        <iframe
          title="Google Map"
          src={mapSrc}
          width="100%"
          height="400"
          style={{ border: 0 }}
          loading="lazy"
        ></iframe>
      </div>

      {/* Modal */}
      {isSubmitted && (
        <div className="modal-overlay">
          <div className="modal-content-custom">
            <button className="close-modal-btn" onClick={closeModal}>
              <FaTimes />
            </button>
            <FaCheckCircle className="success-icon" />
            <h3>Message Sent!</h3>
            <p>Thank you for contacting us.</p>
            <button className="modal-ok-btn" onClick={closeModal}>OK</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContactUs;
